import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const title: Interpolation<Theme> = css`
  font-size: 18px;
  font-weight: 600;
  line-height: 23px;
`

export const tableWrapper: Interpolation<Theme> = css`
  .table-header {
    min-height: 34px;

    div {
      font-weight: 600;
    }
  }

  .table-row {
    min-height: 34px;
    padding: 6px 12px;
  }
`

export const divider: Interpolation<Theme> = (theme) => css`
  height: 1px;
  width: 100%;
  margin: 12px 0;
  background: ${theme.colors.backgroundOne};
`
